import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const TextAlignCenter: SvgComponent = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M17 18H7M20 14H4M17 10H7M20 6H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);
